<template>
	<div>
		<c-input v-model="longitude" :name="lngName" type="hidden"></c-input>
		<c-input v-model="latitude" :name="latName" type="hidden"></c-input>
		<c-input v-model="region" name="_region" placeholder="省、市、区/县" readonly @click.native="handle">
			<template #appendIcon>
				<i class="tf">&#xe6d7;</i>
			</template>
		</c-input>
		<c-input v-model="address" :name="addressName" placeholder="详细街道地址" style="margin-top: 6px;"></c-input>
	</div>
</template>

<script>
	export default {
		name: 'cLocation',

		props: {
			lngName: String,
			latName: String,
			addressName: String
		},
		
		data() {
			return {
				longitude: '',
				latitude: '',
				region: '',
				address: ''
			}
		},

		computed: {
			lngLat() {
				return this.longitude && this.latitude ? `${this.longitude},${this.latitude}` : '';
			}
		},

		watch: {
			lngLat(val) {
				clearTimeout(this._timer);
				this._timer = setTimeout(() => {
					if (val) {
						this.request({
							url: '/location/analysis',
							data: {
								longitude: this.longitude,
								latitude: this.latitude
							},
							success: data => {
								this.longitude = data.longitude;
								this.latitude = data.latitude;
								this.region = `${data.province_name}${data.city_name}${data.county_name}`;
							}
						});
					} else {
						this.longitude = this.latitude = this.region = this.address = '';
					}
					this.$emit('updateLngLat', val);
				}, 100);
			}
		},

		methods: {
			handle() {
				this.globalDialog('locationSelector', {
					data: {
						center: this.lngLat ? this.lngLat.split(',') : ''
					}
				}, data => {
					if (this.longitude != data.lng || this.latitude != data.lat) {
						this.address = data.address;
					}
					this.longitude = data.lng;
					this.latitude = data.lat;
				});
			}
		}
	}
</script>

<style lang="stylus">
</style>